export enum ColumnFilterTypes {
    DATE = "date",
    DATE_TIME = "dateTime",
    AMOUNT = "amount",
  }